'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Faq = void 0;
var $ = require("jquery");
var Faq = /** @class */ (function () {
    function Faq() {
        // よくある質問 表示切替
        $('.trigFaqControll').on('click', function (e) {
            $('.trigFaqControll').attr('data-active', 'false');
            $(e.currentTarget).attr('data-active', 'true');
            var category = $(e.currentTarget).attr('data-category');
            if (category === 'all') {
                $('.bulletFaqContent').show();
            }
            else {
                $('.bulletFaqContent').hide();
                $('.bulletFaqContent').each(function (index) {
                    var contentCategory = $(this).attr('data-category');
                    if (contentCategory === category) {
                        $(this).show();
                    }
                });
            }
        });
        // 質問の表示 / 非表示切り替え
        $('.trigQuestion').on('click', function (e) {
            if (!$(e.currentTarget).next().is(':animated')) {
                var isShow = $(e.currentTarget).attr('data-show');
                if (isShow === 'false') {
                    $(e.currentTarget).attr('data-show', 'true');
                    $(e.currentTarget).next().slideDown();
                }
                else {
                    $(e.currentTarget).attr('data-show', 'false');
                    $(e.currentTarget).next().slideUp();
                }
            }
        });
    }
    return Faq;
}());
exports.Faq = Faq;
exports.default = Faq;
